export const CURRENCYLIST_SEARCH = 'CURRENCYLIST_SEARCH';
export const CURRENCYLIST_PAGE = 'CURRENCYLIST_PAGE';
